// ControlTableView.js

import 'jquery-ui/themes/base/base.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/progressbar.css';
import 'jquery-ui/themes/base/tooltip.css';
import $ from 'jquery';
import constants        from "Constants";
import BaseControlView from 'BaseControlView';
import eventBus         from 'EventBus';
import tableService from 'TableService';
import themeService     from 'ThemeService';
import util from 'util/Util';
import _ from 'lodash';
import template from 'advanced-inputs/control_table.ejs';  
import listService from '../../service/ListService';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';
//=====================================================================
//
// An instance of the view represents a table compound control.
//
//=====================================================================
class TableControlView extends BaseControlView  {

        initialize( opts ) {

            super.initialize( opts );


            const modelObj = this.model.toJSON();

            this.template = template;

            this.tagName = 'div';
            this.family = constants.CONTROL_ADVANCED_INPUTS;
            this.icon = 'pf-table';
            this.jqGridTable = '';
            
            this.events = {
            };

            this.listenTo( eventBus, 'TableThemeChange', this.themeChangeRender);
            this.listenTo( this.model, 'change:gridData', this.render);
            this.listenTo(this.model, 'change', this.render);
            this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);


            if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
                this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
            }

            return this;
        }

        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'TableControlView';
        }

        getColumnDef() {
            let def = [];
            let gridData = this.model.get('gridData');
            let index = 0;
            let localizedHeader = "";
            gridData.forEach(d => { 
                if (d) {
                    localizedHeader = util.getLocalizedText(d.id, 'header') || d.attributes.header;  
                    def[index] = localizedHeader;                   
                    index++;
                }                
            });

            return def;
        }

        getColumnModel() {
            let def = [];
            let gridData = this.model.get('gridData');
            let index = 0;

            gridData.forEach(d => { 
                if (d) {
                    def[index] = d.attributes; 
                    def[index].sortable = false;
                    def[index].width = parseInt(def[index].width);

                    index++;
                }
            });

            return def;
        }

        getColumns() {
            return this.model.get('gridData');
        }

        getColumn( id ) {
            const cols =  _.filter(this.getColumns(), c => id === c.id );
            return _.first(cols);
        }

        makeColumnsWithEqualWidthSize(columns,gridWidth){
            const prevWidth = columns.map(c => c.width);
            const displayedColumns = columns.filter(c => { return c.stateDisplay !== "hidden"});
            const columnCount = displayedColumns.length;
            const columnLength=((parseInt(gridWidth) )/ columnCount);

            displayedColumns.forEach((column)=>{
                    column.width=columnLength;
            });
            this.model.set('gridColumnsEven',false,{silent:true});

            // PF-5745
            undoService.add({
                undo: () => {    
                    displayedColumns.forEach((column, index)=>{
                        column.width=prevWidth[index];
                    });
                    this.model.set('gridColumnsEven',false,{silent:true});
                    this.render();
                },
                redo: () => {
                    displayedColumns.forEach((column)=>{
                        column.width = columnLength;
                    });
                    this.model.set('gridColumnsEven',false,{silent:true});
                    this.render();
                }
            }, textConstants.UNDO_MOVE);
        }

        adjustLastColumnWidth(width,newWidth,iCol,gridColumnsEvenProp){
            // PF-1401 Validating Last Column to be fully resized
            let currentGridData=Object.assign([],this.model.get('gridData'));
             currentGridData[iCol].attributes.width=newWidth;

            this.model.set('gridData',currentGridData,{silent:true});
            this.model.set(gridColumnsEvenProp, false, {silent: true});
            this.render()
        }

        adjustAfterRender(){
            if (listService.isResizing) {
                return;
            }

            let allowColumnResize=this.model.get('allowColumnResize') || false;

            const scrollbarWidth = 18;
            const myId = this.model.get('id');

            const props = this.model.toJSON();
            this.resolveBorderProps(props);
          
            //PF-9523 Set container width and height, it must take into account the border size
            const containerWidth = util.extractNum(this.model.get('width')) + (props.borderSize * 2);
            const containerHeight = util.extractNum(this.model.get('height')) + (props.borderSize * 2);

            $('#' + myId).css({
                "width": containerWidth + "px", 
                "height": containerHeight + "px"
            });

            $('#' + myId + ".size-handle-top").css("width", containerWidth + "px");
            $('#' + myId + ".size-handle-left").css("height", containerHeight + "px");       
            
            const container = $('#' + myId + ' .pf-control-core');
            container.css({
                "width": containerWidth + "px", 
                "height": containerHeight + " - 10% px",
                'border-color' : props.borderColor,
                'border-width' : props.borderSize + 'px',
                'border-style' : props.borderStyle,
                'border-radius' : props.cornerRadius + 'px'
            });
     

            //PF-9523 27px is the height of the footer
            const adjustForFooter = this.model.get('buttons') === 'bottom' ? - 27: 0;
            const adjustForHeader = util.isTrue(this.model.get('showHeader')) ? - (this.model.get('headerHeight')) : 0;

            //PF-9523 there is a difference of 6px in height between designer and player
            let gridHeight = util.extractNum(this.model.get('height')) + adjustForFooter + adjustForHeader - 6;

            const myColumns = this.getColumnDef();
            const myColumnModels = this.getColumnModel();
            let lastIndex = 0;

            myColumnModels.forEach((columnModel, index)=>{
                columnModel.realWidth = columnModel.width === 0 ? columnModel.realWidth ? columnModel.realWidth : constants.DEFAULT_TABLE_WIDTH : columnModel.width;
                if (columnModel.stateDisplay === 'hidden') {
                    columnModel.hidden = true;
                    columnModel.width = 0;
                } else {
                    columnModel.hidden = false;   
                    columnModel.width = columnModel.realWidth;                 
                    lastIndex = index;
                }
                columnModel.resizable = allowColumnResize;
            });

            // PF-1404: set to true, since the jqGrid documentation specified this property is expecting a boolean, or an integer... a string does not makes sense
            // http://www.trirand.com/jqgridwiki/doku.php?id=wiki:options (shrinkToFit property)
            const gridColumnsEvenProp = 'gridColumnsEven';
            let gridColumnsFitEvenly = this.model.get(gridColumnsEvenProp);

            // PF-2065 - Forms / Reports - Table width scrollbar
            if (typeof gridColumnsFitEvenly === 'undefined'){
                gridColumnsFitEvenly = false;
            }

            if (gridColumnsFitEvenly) {
                this.makeColumnsWithEqualWidthSize(myColumnModels,this.model.get('width'));
            }

             props.rowBGColor = this.resolveThemeProp(props.rowBGColor);
            props.rowBGColorGradient = this.resolveThemeProp(props.rowBGColorGradient);
        
            let width = util.extractNum(this.model.get('width')); 
            // Sum the column widths used for decision to extend final col vs insert the horiz scroll bar
            const columnWidthSum = ( cModel => {
                let sum = 0;
                _.forEach( cModel, (v, k) => {
                    if (v) {
                        sum += parseInt(v.width);
                    }
                });
                return sum;
            })(myColumnModels);

            console.log(`Column width sum: ${columnWidthSum}; new width: ${this.model.get('width')}`);
          
            const dw = width - columnWidthSum;

            if(!gridColumnsFitEvenly){
                if (myColumnModels.length > 0 && dw > 0 ){
                    // Extend final column
                    myColumnModels[lastIndex].width += dw;
                }
            }


            props.alternateRowBgColor = this.resolveThemeProp(props.alternateRowBgColor);
            props.normalRowBgColor = this.resolveThemeProp(props.normalRowBgColor);


            this.jqGridTable = $('#grid_' + myId).jqGrid({
                datatype: "local",
                height: gridHeight,
                shrinkToFit: gridColumnsEvenProp,
                width: this.model.get('width'),
                altRows: true,
                gridComplete: () => {
                    $("#grid_" + myId + " tr.jqgrow:odd").css("background", props.alternateRowBgColor);
                    $("#grid_" + myId + " tr.jqgrow:even").css("background", props.normalRowBgColor);
                    $("#grid_" + myId + " tr.jqgrow td").css("height", props.rowHeight);
                },
                resizeStop: (newWidth, iCol) => {
                   this.adjustLastColumnWidth(width,newWidth,iCol,gridColumnsEvenProp);
                },
                colNames: myColumns,
                colModel: myColumnModels,
                beforeSelectRow: function(rowid, e) {
                    return false;
                }
            });

            $('#grid_' + myId).addRowData(0, {'Column 1': 'Test', 'Column 2': 'Test'});
            $('#grid_' + myId).addRowData(1, {'Column 1': 'Test', 'Column 2': 'Test'});

            this.resolveFontProps(props);
            themeService.resolveHeaderFontProps(props);

            const t = $('#' + myId + '  table thead th');
            t.css({'font-size': props.headerFontSize + 'px', 'font-family': '"' + props.headerFontFamily + '"' } );
            t.css({'font-weight': props.headerTextWeight.replace('!important', '')  });
            t.css({'font-style': props.headerTextStyle.replace('!important', '') });

            props.headerBgColor = this.resolveThemeProp(props.headerBgColor);
            props.headerBgColorGradient = this.resolveThemeProp(props.headerBgColorGradient);

            const webkitHeaderBackground = '-webkit-linear-gradient(top, ' + props.headerBgColor + ', ' + props.headerBgColorGradient + ')' ;
            t.css({'background' : webkitHeaderBackground });

            const msHeaderBackground = '-ms-linear-gradient(top, ' + props.headerBgColor + ', ' + props.headerBgColorGradient + ')' ;
            t.css({'background' : msHeaderBackground });

            props.headerTextColor = this.resolveThemeProp(props.headerTextColor);
            t.css({'color' : props.headerTextColor });

            

            props.backgroundColor = this.resolveThemeProp(props.backgroundColor);
            const view = $('#' + myId + ' .table-footer');
            view.css({'background': props.backgroundColor });

            $('#' + myId + ' .ui-jqgrid-hdiv').css('height', this.model.get('headerHeight'));

            $('#' + myId + ' .ui-jqgrid-hdiv span.ui-jqgrid-resize').css('height', this.model.get('headerHeight'));

            if (!this.model.get('allowColumnResize')) {
                t.append('<span class="emptyResizeColumn">&nbsp;</span>');
            }
            else {
                $('#' + myId + ' .ui-jqgrid .ui-jqgrid-resize-ltr').css('margin',0);
            }

            if (!util.isTrue(this.model.get('showHeader'))) {
                $('#' + myId + ' .ui-jqgrid-hdiv').hide();
            }

            const obBorder = $('#' + myId + ' .outOfBounds');
            if (obBorder && obBorder.length > 0) {
                const obWidth = obBorder[0].offsetWidth;
                $('#' + myId + ' .outOfBounds').css('width', obWidth + 8);
            }

            // Column Header Event
            $('#' + myId + ' th').on('click', e => {
                e.stopPropagation();

                const me = $(e.currentTarget);
                const rowid = $(`div#${myId} th`).index(me);

                tableService.showColumnProperties(rowid, this.model);
                const id=me.attr('id');
                 $(`#${myId} td`).removeClass('column-selection');
                 $(`#${myId} th`).removeClass('column-selection');
                 $(me).addClass('column-selection');
                 $(`td[aria-describedby='${id}']`).addClass("column-selection");
                 listService.isTableColumnSelected = true;
            });

            tableService.buildSelectList(this.model);
            util.setGridScrollPos(this.model, '#gview_gridColumns > div.ui-jqgrid-bdiv');

        }

}

export default TableControlView;
